import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'shared/utils/canvasToBlob';
import React from 'react';
import './wdyr';
import ReactDOM from 'react-dom';
import App from './App';
import 'shared/userLocale/i18n';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const isProduction = process.env.NODE_ENV === 'production';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorkerRegistration.register({
  onUpdate: async function(registration) {
    // We want to run this code only if we detect a new service worker is
    // waiting to be activated.
    // Details about it: https://developers.google.com/web/fundamentals/primers/service-workers/lifecycle
    if (registration && registration.waiting) {
      await registration.unregister();
      // Makes Workbox call skipWaiting()
      registration.waiting.postMessage({type: 'SKIP_WAITING'});
      // Once the service worker is unregistered, we can reload the page to let
      // the browser download a fresh copy of our app (invalidating the cache)
      window.location.reload();
    }
  }
});

window.addEventListener('error', async function() {
  if (!navigator.serviceWorker) {
    return;
  }

  /**
   * @see https://medium.com/@FezVrasta/service-worker-updates-and-error-handling-with-react-1a3730800e6a
   */
  if (isProduction) {
    const registration = await navigator.serviceWorker.ready;
    if (registration.installing || registration.waiting) {
      navigator.serviceWorker.ready.then(async function(registration) {
        await registration.unregister();
        window.location.reload();
      });
    }
  }
});
